<script>
  // # # # # # # # # # # # # #
  //
  //  Main
  //
  // # # # # # # # # # # # # #

  // *** POLYFILLS
  import "intersection-observer";
  import "whatwg-fetch";
  // import "es6-shim";

  // *** IMPORT
  import { Router, Link, Route } from "svelte-routing";
  import MediaQuery from "svelte-media-query";

  // *** COMPONENTS
  import Navigation from "./Components/Navigation.svelte";
  import MobileNavigation from "./Components/MobileNavigation.svelte";

  // ROUTES
  import Feed from "./Routes/Feed.svelte";
  import List from "./Routes/List.svelte";
  import Article from "./Routes/Article.svelte";
  import Shortlist from "./Routes/Shortlist.svelte";
  import Vision from "./Routes/Vision.svelte";
  import Contact from "./Routes/Contact.svelte";
  import Tags from "./Routes/Tags.svelte";
  import Error404 from "./Routes/Error404.svelte";

  // *** VARIABLES
  const baseURL = "https://completeworks.ch/";

  const routingParams = {
    feed: {
      endpoint: baseURL + "feed.json"
    },
    exhibitions: {
      list: {
        title: "Exhibitions",
        endpoint: baseURL + "gallery/exhibitions.json"
      },
      article: {
        endpoint: baseURL + "gallery/exhibitions/",
        gallery: true
      }
    },
    curatorialProjects: {
      list: {
        title: "Curatorial Projects",
        endpoint: baseURL + "gallery/curatorial-projects.json"
      },
      article: {
        endpoint: baseURL + "gallery/curatorial-projects/",
        gallery: true
      }
    },
    artists: {
      list: {
        title: "Artists",
        endpoint: baseURL + "gallery/artists.json",
        gallery: true
      },
      article: {
        endpoint: baseURL + "gallery/artists/",
        gallery: true
      }
    },
    projects: {
      list: {
        title: "Projects",
        endpoint: baseURL + "architecture/projects.json"
      },
      article: {
        endpoint: baseURL + "architecture/projects/",
        architecture: true
      }
    },
    brands: {
      list: {
        title: "Brands",
        endpoint: baseURL + "architecture/brands.json",
        architecture: true
      },
      article: {
        endpoint: baseURL + "architecture/brands/",
        architecture: true
      }
    },
    vision: {
      title: "About",
      endpoint: baseURL + "about.json"
    },
    contact: {
      title: "Contact",
      endpoint: baseURL + "contact.json"
    },
    tags: {
      title: "Tags",
      endpoint: baseURL + "tags.json"
    }
  };
</script>

<style lang="scss" global>
  @import "./_variables.scss";

  body,
  html {
    font-size: $font-size-large;
    line-height: $normal-line-height;
    margin: 0;
    padding: 0;
    background: $white;
    color: $black;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    @include hide-scroll;

    &.no-scroll {
      overflow: hidden;
    }
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  * {
    outline: none;
  }

  a {
    text-decoration: none;
    color: currentColor;
  }

  p {
    margin-top: 0;
    margin-bottom: $small-margin;
    margin-bottom: $main-margin;
  }

  ::selection {
    background: #e4e4e4;
    /* WebKit/Blink Browsers */
  }

  ::-moz-selection {
    background: #e4e4e4;
    /* Gecko Browsers */
  }
  .contact__body {
    a {
      color: currentColor;
      border-bottom: none;

      @include normal-hover-state;
    }
  }
</style>

<MediaQuery query="(min-width: 800px)" let:matches>
  {#if matches}
    <Navigation />
  {:else}
    <MobileNavigation />
  {/if}
</MediaQuery>

<Router>
  <!-- FEED -->
  <Route path="/" component={Feed} {...routingParams.feed} />

  <!-- GALLERY: EXHIBITIONS -->
  <Route
    path="gallery/exhibitions/"
    component={List}
    {...routingParams.exhibitions.list} />
  <Route
    path="gallery/exhibitions/:slug"
    component={Article}
    {...routingParams.exhibitions.article} />

  <!-- GALLERY: ARTISTS -->
  <Route
    path="gallery/artists/"
    component={Shortlist}
    {...routingParams.artists.list} />
  <Route
    path="gallery/artists/:slug"
    component={Article}
    {...routingParams.artists.article} />

  <!-- ARCHITECTURE: PROJECTS -->
  <Route
    path="architecture/projects/"
    component={List}
    {...routingParams.projects.list} />
  <Route
    path="architecture/projects/:slug"
    component={Article}
    {...routingParams.projects.article} />

  <!-- ARCHITECTURE: BRANDS -->
  <Route
    path="architecture/brands"
    component={Shortlist}
    {...routingParams.brands.list} />
  <Route
    path="architecture/brands/:slug"
    component={Article}
    {...routingParams.brands.article} />

  <!-- PAGE: ABOUT -->
  <Route path="about" component={Vision} {...routingParams.vision} />

  <!-- TAGS -->
  <Route path="tags/" component={Tags} {...routingParams.tags} />
  <Route path="tags/:query" component={Tags} {...routingParams.tags} />

  <!-- PAGE: CONTACT -->
  <Route path="contact" component={Contact} {...routingParams.contact} />

  <!-- 404 -->
  <Route component={Error404} title="404" />
</Router>
